import { createApp } from 'vue'
import App from './App.vue'
import {createAuth0} from "@auth0/auth0-vue";
import router from './router'
import VueJwtDecode from 'vue-jwt-decode'
import {createPinia} from 'pinia'

import { useOrderStore } from "@/Stores/orders.js";

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
// Import your custom bootstrap build (SCSS compiled to CSS by Vite/Webpack)
import "./assets/custom-bootstrap.scss"





// createApp(App).mount('#app')
const app = createApp(App)
const pinia = createPinia()

const auth0 = createAuth0({
    domain: process.env.VUE_APP_DOMAIN,
    client_id: process.env.VUE_APP_CLIENT_ID,
    redirect_uri: window.location.origin,
    audience: process.env.VUE_APP_AUDIENCE,
    useRefreshTokens: true,
    cacheLocation: "localstorage"
})

app.directive('scroll-reveal', {
    mounted(el) {
        el.style.opacity = '0'
        el.style.transform = 'translateY(30px)'
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    el.style.transition = 'all 0.8s ease-out'
                    el.style.opacity = '1'
                    el.style.transform = 'translateY(0)'
                    observer.unobserve(el)
                }
            },
            { threshold: 0.1 }
        )
        observer.observe(el)
    }
})

// import callAPI from './Javascript/callAPI'
//
// const {apiGet, apiPut} = callAPI()
app
    .use(router)
    .use(pinia)
    .use(auth0)
    .mount('#app')

const orderStore = useOrderStore();
orderStore.loadFromStorage();

// router.beforeEach(async(to,from)=>{
//     const {permission} = to.meta;
//     if(permission){
//         const token = await auth0.getAccessTokenSilently().catch((error)=>{
//             console.log(error)
//             return auth0.loginWithRedirect()
//         })
//         const userPermissions = VueJwtDecode.decode(token).permissions
//         if(!userPermissions.includes(permission)) {
//             return from.path
//         }
//     }
// })

router.beforeEach(async (to, from) => {
    const { permissions } = to.meta || {}

    if (!permissions || permissions.length === 0) {
        return true
    }

    try {
        const token = await auth0.getAccessTokenSilently()
        const userPermissions = VueJwtDecode.decode(token).permissions || []

        const hasAccess = permissions.some(p =>
            userPermissions.includes(p)
        )

        if (!hasAccess) {
            return from.fullPath
        }

        return true

    } catch (error) {
        console.log(error)
        return auth0.loginWithRedirect()
    }
})

router.afterEach((to) => {
    if (to.meta?.title) {
        document.title = to.meta.title;
    }else{
        document.title = "OE Alternatives"
    }
    if (to.meta?.description) {
        let meta = document.querySelector('meta[name="description"]');
        if (!meta) {
            meta = document.createElement('meta');
            meta.name = 'description';
            document.head.appendChild(meta);
        }
        meta.content = to.meta.description;
    }
    // --- Canonical Tag ---
    if (to.meta?.canonical) {
        let link = document.querySelector('link[rel="canonical"]');

        if (!link) {
            link = document.createElement('link');
            link.rel = 'canonical';
            document.head.appendChild(link);
        }

        link.href = to.meta.canonical;
    }
});



